import 'jquery.easing';
import 'svgxuse';
import 'bootstrap';
import INIT from './module/init';
import HOME from './page/home';
import FORM from './page/form';

const $ = jQuery;

const [w,l] = [window,location]

INIT()

switch(l.pathname.replace(/^([^.]+\/)([^.]+)\.(php|html)/,'$1')){
  case '/': HOME(); break
  case '/entry/':
  case '/inquiry/': FORM(); break
}